import {
    Component,
    OnDestroy,
    OnInit,
    ElementRef,
    Inject,
    PLATFORM_ID,
    ApplicationRef,
    AfterViewInit,
    ViewChild,
    HostListener,
    Injector
} from "@angular/core";
import { Subscription } from "rxjs";
import { ResizeEvent } from "angular-resizable-element";
import { TradeRequestModel } from "../../model/trade.request.data";
import { DataService, initRequest, getSymbolOrder, symbolsForexOrder } from "../../services/data/data.service";

import { BoxQuotaData } from "../../model/box.quote.data";

import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";

import { QuotePanelsTabsList } from "../../enums/QuotePanelsTabs.list";

import { MainUIServiceService } from "../../services/main-uiservice.service";
import { tradeDeskTabsList } from "../tradedeskTabs/tradedeskTabs.list";
import { OrderOperationType } from "../modals/orderentry/orderentry.component";
import {
    LoginRs,
    OrderRs,
    CancelRs,
    TradeClosedRs,
    PositionEnteredRs,
    PartialCloseRs
} from "../../interfaces/service.response";
import { ShowOrderNotificationModal } from "../modals/ordernotification/ordernotification.component";
import { quoteFilterTabsParams } from "../quoteFilterTabs/quoteFilterTabs.list";
import { OrderByPipe } from "../../pipes/orderby";
import { ReversePipe } from "../../pipes/reverse";
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";
import { SelectedParametersSetModal } from "../modals/SelectedParametersSet/SelectedParametersSet.component";
import { AppComponentBase } from "../../services/AppComponentBase";
import { ShowTradeClosedModal } from "../modals/tradeclosed-info/tradeclosed-info.component";
import { TradeClosedNotificationParams } from "../trade-closed-notification/trade-closed-notification.component";
import { OrderNotificationParams } from "../order-notification/order-notification.component";
import {
    PositionEnteredNotificationComponent,
    PositionEnteredNotificationParams
} from "../position-entered-notification/position-entered-notification.component";
import { ICompetitionData } from "../../interfaces/IcompetitionData";
import { Tournament, TournamentWithAccountId, UserTradingProvider, Adveristment } from "../../api/DixApiClient";
import { AlertState } from "../../enums/alert-state";
import { ShowLoginModal } from "../modals/login/show-login-modal";
import { ShowOrderNotification } from "../order-notification/show-order-notification";
import { ShowPositionEnteredNotification } from "../position-entered-notification/show-position-entered-notification";
import { ShowTradeClosedNotification } from "../trade-closed-notification/show-trade-closed-notification";
import { ShowModalOrderEntry } from "../modals/orderentry/show-order-entry-modal";
import { ShowAddToBasketModal } from "../modals/addsymbolstobasket/show-add-symbols-to-basket-modal";
import { showDisconnectionInfoModal } from "../modals/disconnectionInfo/show-disconection-info-modal";
import { setInterval } from "timers";
import { challengeTabsParams, challengeTabsList } from "../challenges/challenge.tab.list";
import { ShowSimpleNotification } from "../simple-notification/show-simple-notification";
import { SimpleNotificationParams } from "../simple-notification/simple-notification.component";
import { RoutingService } from "../../services/routing.service";
import { ShowCompetitionRegisterModal } from "../modals/competitionRegistration/show-competition-registration-modal";
import * as moment from "moment";
import { NgbCarousel } from "@ng-bootstrap/ng-bootstrap";
import { Carousel } from "../controls/carouselAll/carouselAll.component";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../utils";
import { LoginRequestModel } from "../../model/login.request.data";
import { ActivatedRoute } from "@angular/router";
import { fbq } from "../modals/login/login.component";
import { showScannerAutoTrialModal } from "../scanner/modals/ScannerAutoTrial/show-ScannerAutoTrial-modal";
import { isDefaultChangeDetectionStrategy } from "@angular/core/src/change_detection/constants";
import { showScannerTrialPopupModal } from "../scanner/modals/ScannerTrialPopup/show-ScannerTrialPopup-modal";
import { ShownoBoundsModal } from "../modals/noBounds/show-noBounds-modal";
import { GainService } from "../../services/GAIN/gain.service";
import { Providers } from "../../enums/providers";
import { ShowLoginProviderModal } from "../modals/login-provider/show-login-provider-modal";
import { ShowOpenLiveAccountModal } from "../modals/open-live-account/open-live-account.component";
import { ShowOpenLiveAccountMobileModal } from "../modals/mobile-open-live-account/mobile-open-live-account.component";
import { AChartComponent } from "../achart/achart.component";
import { ChartDisplayMode } from "../../enums/ChartDisplayMode.list";
import { DivideResizerComponent } from "../divide-resizer/divide-resizer.component";

@Component({
    selector: "home",
    template: require('./home.component.html'),
    styles: [require('./home.component.css'), require('../../appStyles.css')]
})
export class HomeComponent extends AppComponentBase implements OnDestroy, OnInit, AfterViewInit {
    @ViewChild("headerBoxesContainer") public headerBoxesContainer!: ElementRef;
    @ViewChild("mainColumn") public mainColumn!: ElementRef;
    @ViewChild("menuPan") public menuPan!: ElementRef;
    @ViewChild("competitionInformationContainer") public competitionInformationContainer!: ElementRef;
    @ViewChild("userSelectMainCol") public userSelectMainCol!: ElementRef;
    //@ViewChild('carousel') carousel!: NgbCarousel;
    @ViewChild("divResizer") public divResizer!: DivideResizerComponent;
    public currentYear:string = "2020";

    public get canShowSlider(): boolean {
        return false;//this.workspace.showSLider;
    }

    get hasOpenModals() {
        return this.modalService.hasOpenModals();
    }
    public tradeDestUserSelectWidthPx = 400;
    public get tradeDeskUserSelectEnabled() {
        return !this.showQuotePanel;
    }

    public get boxes(): BoxQuotaData[] {
        return this.workspace.boxes;
    }
    public set boxes(value: BoxQuotaData[]) {
        this.workspace.boxes = value;
    }

    public get headerBoxesContainerWidth() {
        return this.headerBoxesContainer.nativeElement.offsetWidth || 0;
    }

    get liveAccount(): boolean {
        return this.dataService.LiveAccount;
    }

    protected _dataFeedStatus: number = 1;

    get dataFeedStatus(): number {
        return this._dataFeedStatus;
    }

    get homeComponent() {
        return this;
    }

    public boxesToMerge: BoxQuotaData[] = [];
    private subscription: Subscription;

    public activeTradeDeskTab: string = tradeDeskTabsList.ORDERS;
    public tabs = QuotePanelsTabsList;
    public previousLayout: string[][] = [];
    private _chartsRowState: string[][] = [
        ["col-6", "h-50"],
        ["col-6", "h-50"],
        ["col-6", "h-50"],
        ["col-6", "h-50"]
    ];
    //  private menuWidth: number = -1;

    public get sidebarBadge() {
        if (this.workspaceService.data.alerts == null) return 0;
        return this.workspaceService.data.alerts.filter(
            a => this.workspaceService.data.getAlertState(a) == AlertState.Unread
        ).length;
    }

    public get loggedIn(): boolean {
        return this.workspace.loggedIn;
    }

    public get quoteDisplayMode(): number {
        return this.workspace.quoteDisplayMode;
    }
    public set quoteDisplayMode(v: number) {
        this.workspace.quoteDisplayMode = v;
    }

    public get chartsRowState(): string[][] {
        return this._chartsRowState;
    }
    public set chartsRowState(v: string[][]) {
        this.previousLayout = this._chartsRowState;
        this._chartsRowState = v;
        if (this.divResizer) {
            setTimeout(() => {
                this.divResizer.position = this.divResizer.position;
            }, 100);
        }
    }

    public get leftHeaderWidth() {
        return this.menuWidth;
    }

    public get leftHeaderStyle() {
        if (!this.showQuotePanel || this.leftHeaderWidth == -1) return {};
        return {
            "width.px": this.leftHeaderWidth,
            "max-width.px": this.leftHeaderWidth,
            flex: "0 0 " + this.leftHeaderWidth + "px"
        };
    }

    public get rightHeaderStyle() {
        if (!this.showQuotePanel || this.leftHeaderWidth == -1) return {};

        return {
            "max-width": "calc(100% - " + this.leftHeaderWidth + "px)",
            flex: "0 0 calc(100% - " + this.leftHeaderWidth + "px)"
        };
    }

    private _defaultTradeDeskHeight: number = 400;
    private _minTradeDeskHeight: number = 0;
    private _hiddenTradeDeskHeight: number = -18;
    public loginProvider?: Providers;
    public get tradeDeskHeight() {
        if (!this.showTradeDesk) return this._hiddenTradeDeskHeight;

        return this.workspace.tradeDeskHeight;

        //   if (tradeDeskHeight != null) return parseFloat(tradeDeskHeight);

        //    return this._defaultTradeDeskHeight;
    }

    public set tradeDeskHeight(value: number) {
        this.workspace.tradeDeskHeight = value;
        // this.workspace.setToUserStore("tradeDeskHeight", value.toString());
    }

    public scrollbarOptions = { axis: "yx", theme: "minimal-dark" };
    private activatedRoute!: ActivatedRoute;
    //public providerModal = ShowLoginProviderModal(this.modalService, false, "", this.workspace.mobileMode);
    constructor(
        injector: Injector,
        @Inject(PLATFORM_ID) private platformId: Object,
        public mainUIService: MainUIServiceService
    ) {
        super(injector);
        (window as any).home = this;
        // make tick on Angular App - check all changes in components and update UI
        setInterval(() => {
            this.workspace.AppTick();
        }, 100);
        this.workspace.AppTick();

        this.workspace.providerModalHome = this;

        this.cookieService.setCookie("IsLoggedIn", "false", 1, "/");
        this.cookieService.setCookie("orderLoginAction", "false", 1, "/");

        this.activatedRoute = injector.get(ActivatedRoute);
        this.workspace.specialToken = this.activatedRoute.snapshot.queryParams["t"];
        this.workspace.challangeToken = this.activatedRoute.snapshot.queryParams["c"];
        this.currentYear = moment().format("YYYY");
        // if (this.workspace.specialToken && this.workspace.specialToken != "") {
        //     if ((<any>window).fbq != null) {
        //         (<any>window).fbq("trackCustom", "complete registration");
        //     }
        // }
        // if(this.workspace.challangeToken=="1")
        // {

        //     //this.workspace.isFirstLogin = true;
        //      this.workspace.allowFunnelAction = true;
        //      this.globaGridMode.funnelUserActive.next(true);

        // }

        this.subscription = this.dataService.dataSubscriber.subscribe(response => {
            switch (response.Type) {
                case "LoginRs":
                    var loginRs: LoginRs = <LoginRs>response;
                    if (!loginRs.OK) {
                        console.log("login false");
                        this.cookieService.deleteCookie("_zp");
                        this.cookieService.deleteCookie("_xu");
                        this.cookieService.deleteCookie("_r");
                        if (!this.workspaceService.data.LoginModalCreated) {
                            ShowLoginModal(this.modalService, true, "", this.workspace.mobileMode);
                        }
                    } else {
                        if (loginRs.Provider == Providers.OANDA && loginRs.IsProviderBound == false) {
                            this.hideApp = true;
                            //      alert("NOBOUNDS");
                            ShownoBoundsModal(this.modalService, this.workspace.mobileMode, loginRs.Provider);
                        } else if (loginRs.Provider == Providers.GAIN) {
                            this.loginProvider = Providers.GAIN;
                            this.hideApp = true;

                            // try {
                            //     ShowLoginProviderModal(this.modalService, false, "", this.workspace.mobileMode).finally(() => {
                            //         console.log("Login GAIN")
                            //         this.hideApp = false;
                            //     });
                            // } catch(e) {
                            //     console.log(e);
                            // }
                        }
                        {
                            this.workspace.userTagList = loginRs.Tags;
                            // show trial popup
                            setTimeout(() => {
                                if (this.workspace.userId <= 32016) {
                                    if (
                                        this.workspace.anyProductIsActive == false &&
                                        this.workspace.anyProductIsTrial == false
                                    ) {
                                        var tp = Number(this.cookieService.getCookie("trialpopup") || "0");
                                        tp = isNaN(tp) ? 0 : tp;
                                        if (tp < 3) {
                                            tp++;
                                            this.cookieService.setCookie("trialpopup", tp.toString(), 1000);
                                            this.showScannerTrial();
                                        }
                                    } else {
                                        this.cookieService.deleteCookie("trialpopup");
                                    }
                                }
                            }, 60 * 1000);
                        }
                    }
                    // this.showSelectSetModal();
                    break;
                case "DisconnectRs":
                    console.log("DisconnectRs");

                    this.workspace.forceDisconnection = true;
                    // setTimeout(() => {
                    //     this.forceLogout();
                    // }, 20000);
                    showDisconnectionInfoModal(this.modalService, this.workspace.mobileMode);

                    break;
                case "OrderRs":
                    var orderRs: OrderRs = <OrderRs>response;
                    //ShowOrderNotificationModal(this.modalService, orderRs);
                    //  debugger;
                    ShowOrderNotification(this.toastr, new OrderNotificationParams(orderRs), this.workspace.mobileMode);
                    break;
                case "CancelRs":
                    var cancelRs: CancelRs = <CancelRs>response;
                    if (cancelRs.Error != "") {
                        //ShowOrderNotificationModal(this.modalService, cancelRs);
                        ShowOrderNotification(
                            this.toastr,
                            new OrderNotificationParams(cancelRs),
                            this.workspace.mobileMode
                        );
                    }
                    break;
                case "PartialCloseRs":
                    var partialCloseRs: PartialCloseRs = <PartialCloseRs>response;
                    //   if (cancelRs.Error != "") {
                    //ShowOrderNotificationModal(this.modalService, cancelRs);
                    //       partialCloseRs.Error = "ERROR ERROR ERROR ERROR ERROR ERROR ERROR ERROR ERROR ERROR ";
                    ShowTradeClosedNotification(
                        this.toastr,
                        new TradeClosedNotificationParams(
                            partialCloseRs.FillPrice,
                            partialCloseRs.Pips,
                            partialCloseRs.Profit,
                            partialCloseRs.Qty,
                            partialCloseRs.Symbol,
                            true,
                            partialCloseRs.Error
                        ),
                        this.workspace.mobileMode
                    );
                    break;
                //    }
                // break;
                case "PositionEnteredRs":
                    ShowPositionEnteredNotification(
                        this.toastr,
                        new PositionEnteredNotificationParams(response as PositionEnteredRs),
                        this.workspace.mobileMode
                    );
                    break;
                case "TradeClosedRs":
                    var tradeclosed: TradeClosedRs = <TradeClosedRs>response;
                    //  ShowTradeClosedModal(this.modalService, tradeclosed);
                    ShowTradeClosedNotification(
                        this.toastr,
                        new TradeClosedNotificationParams(
                            tradeclosed.FillPrice,
                            tradeclosed.Pips,
                            tradeclosed.Profit,
                            tradeclosed.Qty,
                            tradeclosed.Symbol
                        ),
                        this.workspace.mobileMode
                    );
                    break;
                case "CloseRs":
                    const closeRs = response as any;
                    ShowSimpleNotification(
                        this.toastr,
                        new SimpleNotificationParams("Error", closeRs.Error, true),
                        this.workspace.mobileMode
                    );
                    break;
                case "EditRs":
                    const editRs = response as { Error: string; OrderNo: string };
                    const error = editRs.Error != "";
                    const message = error ? editRs.Error : `Order ${editRs.OrderNo} Edited Successfully`;
                    ShowSimpleNotification(
                        this.toastr,
                        new SimpleNotificationParams(`Order Edit #${editRs.OrderNo}`, message, error),
                        this.workspace.mobileMode
                    );
                    break;
            }
        });

        this.mainUIService.TabsActive.subscribe(currentTradeDeskTabId => {
            this.activeTradeDeskTab = currentTradeDeskTabId;
            this.workspace.activeTradeDeskTab = currentTradeDeskTabId;
            this.globaGridMode.tradeTab.next(currentTradeDeskTabId);
        });

        this.activeLayoutChartService.subscriber.subscribe(currentLayoutType => {
            this.setChartDisplaySet(currentLayoutType);
        });

        this.symbolTypeService.subscriber.subscribe(activeFilter => {
            this.searchQuoteFullText(this._currentSearchString);
        });

        if (
            (this.workspace.userName &&
                this.workspace.userPassword &&
                this.workspace.userName != "" &&
                this.workspace.userPassword != "" &&
                this.workspace.remember) ||
            (this.workspace.specialToken && this.workspace.specialToken != "")
        ) {
            console.log("SEND LOGIN - witahout login modal");
            console.log(this.workspace.loginProvider);
            Utils.waitFor(
                () => this.dataService.conectionOpened,
                () =>
                    this.workspace.sendLogin(
                        this.workspace.userName,
                        this.workspace.userPassword,
                        this.workspace.specialToken,
                        this.workspace.loginProvider
                    )
            );
        } else {
            console.log("LOGIN - with login modal");
            if (!this.workspaceService.data.LoginModalCreated) {
                ShowLoginModal(
                    this.modalService,
                    false,
                    this.cookieService.getCookie("IsLoggedIn") || "",
                    this.workspace.mobileMode
                ).then(
                    () => {
                        //       this.workspace.loggedIn = true;
                    },
                    () => {
                        this.workspace.loggedIn = false;
                    }
                );
            }
        }

        this.globaGridMode.changeActiveBasket.subscribe(v => {
            this.searchQuoteFullText(this._currentSearchString);

            this.refreshSortOrder = this.activeBasket;

            this.boxes.map(item => {
                item.sortOrder = item.initialSortOrder;
            });

            this.updateSortOrder(v);
            this.refreshSortOrder = Math.random();
        });

        this.globaGridMode.funnelUserActive.subscribe(v => {
            ShowCompetitionRegisterModal(
                this.modalService,
                null,
                true,
                false,
                undefined,
                undefined,
                undefined,
                this.workspace.mobileMode
            );
            this.activeTab = QuotePanelsTabsList.LEADERBOARD;
            this.workspace.challengeActiveTab = challengeTabsList.UPCOMING;
        });

        this.setWords();

        this.getOauthData();
    }

    public ChartCfg(id: string) {
        return this.workspace.charts[id];
    }

    tradedeskButtonClick() {
        if (this.workspace.showScannerPage) this.showTradeDesk = false;

        this.workspace.showScannerPage = false;
        this.showTradeDesk = !this.showTradeDesk;
    }

    public showScannerTrial() {
        if (this.workspace.mobileMode == "desktop")
            showScannerTrialPopupModal(this.modalService, this.workspace, this.workspace.mobileMode);
    }

    private getOauthData(): void {
        var hash = window.location.hash;
        if (hash.indexOf("access_token") > -1 && hash.indexOf("token_type") > -1) {
            hash = hash.replace("#", "?");
            console.log("a");
            $.get("/api/oauth/authorize" + hash);
            window.location.hash = "";
        }
    }

    private _hideApp: boolean = false;
    public get hideApp(): boolean {
        return this._hideApp;
    }
    public set hideApp(value: boolean) {
        this._hideApp = value;
    }

    private _setWordsCount: number = 0;
    public get setWordsCount(): number {
        return this._setWordsCount;
    }
    public set setWordsCount(value: number) {
        this._setWordsCount = value;
    }

    public setWords() {
        this.currentLoadedTitle = this.loadWords[this.setWordsCount];
        this.setWordsCount++;

        if (this.setWordsCount == this.loadWords.length) {
            this.setWordsCount = this.loadWords.length - 1;
        }

        if (this.setWordsCount < this.loadWords.length) {
            setTimeout(() => {
                this.setWords();
            }, 400);
        }
    }

    private loadWords: string[] = ["Wizard", "Charting", "Entry Signals", "S Wizard", "Monitor"];

    public set currentLoadedTitle(v) {
        this.workspace.currentLoadedTitle = v;
    }

    public get currentLoadedTitle(): string {
        return this.workspace.currentLoadedTitle;
    }

    private _refreshSortOrder: number = 0;

    public set refreshSortOrder(v: number) {
        this._refreshSortOrder = v;
    }

    public get refreshSortOrder() {
        return this._refreshSortOrder;
    }

    private _filledOrders: any;

    public set filledOrders(v: any) {
        this._filledOrders = v;
    }

    public get filledOrders() {
        return this._filledOrders;
    }

    private _lockTradeDesk = false;
    public set lockTradeDesk(value: boolean) {
        this.workspace.lockTradeDesk = value;
    }
    public get lockTradeDesk() {
        return this.workspace.lockTradeDesk;
    }

    private _positionsOrders: any;
    public set positionsOrders(v: any) {
        this._positionsOrders = v;
    }

    public get positionsOrders() {
        return this._positionsOrders;
    }

    private _WorkingOrders: any;
    public set WorkingOrders(v: any) {
        this._WorkingOrders = v;
    }

    public get WorkingOrders() {
        return this._WorkingOrders;
    }

    trackByFn(index: number, item: BoxQuotaData) {
        return item.Symbol;
    }

    private _currentSearchString: string = "";
    // searchQuoteFullText(search:string): void {};
    searchQuoteFullText(search: string): void {
        this.boxes.forEach((value: BoxQuotaData) => {
            var str: string = value.Symbol; //this.objectString(value, search);

            this._currentSearchString = search;
            if (str.toUpperCase().search(search.toUpperCase()) === -1) {
                value.searchVisible = false;
            } else {
                value.searchVisible = true;
            }

            if (this.activeBasket != -1 && value.searchVisible != false) {
                let basketSymbols = this.workspace.getActiveBasketItems();
                if (basketSymbols.indexOf(value.Symbol) >= 0) {
                    value.searchVisible = true;
                } else {
                    value.searchVisible = false;
                }
            }

            if (value.searchVisible != false) {
                value.searchVisible = value.Type == this.activeQuoteFilter;
            }

            //  value.searchVisible = false;
        });
    }

    public showProviderModal(provider: string | undefined): Promise<any> {
        return new Promise<any>((rs, rj) => {
            //debugger;

            this.workspace.getUserProviders(this.workspaceService.data.userId).then(v => {
                console.log(v);

                let gain = v.filter((k: any) => {
                    return k.providerId == Providers.GAIN;
                });

                if (gain.length > 0 && provider == Providers.GAIN) {
                    let previousSelectedProvider = gain[0] as UserTradingProvider;

                    if (previousSelectedProvider.token != undefined) {
                        let loginData: { UserName: string; UserPassword: string | null } = JSON.parse(
                            previousSelectedProvider.token
                        );

                        // if(loginData.UserName != "" && loginData.UserPassword && loginData.UserPassword != "") {
                        //     this.gainService.LogOn(loginData.UserName, loginData.UserPassword).then(l => {
                        //         //     debugger;
                        //         this.workspaceService.data.gainLoginResponse = l;
                        //         console.log("Login GAIN")
                        //         this.hideApp = false;
                        //         rs();

                        //     }).catch(e => {
                        //         console.log(e);
                        //         this.hideApp = true;
                        //         alert("providerLoginError");
                        //         rj();
                        //     })
                        // }
                        // else {
                        try {
                            console.log("BLURACTION");
                            this.hideApp = false;
                            this.setBlurFX = true;
                            ShowLoginProviderModal(
                                this.modalService,
                                false,
                                "",
                                this.workspace.mobileMode,
                                loginData.UserName,
                                loginData.UserPassword,
                                false,
                                true
                            ).finally(() => {
                                console.log("Login GAIN");
                                if (this.workspace.gainLoginResponse == undefined) {
                                    if (
                                        this.loginProvider == Providers.GAIN &&
                                        this.currentProvider == Providers.DEMO
                                    ) {
                                        this.globaGridMode.switchProviderSignal.next(Providers.DEMO);
                                        this.loginProvider = undefined;
                                        rs();
                                    } else {
                                        this.globaGridMode.switchProviderSignal.next(true);
                                    }
                                    //   this.currentProvider
                                    this.setBlurFX = false;
                                    //  this.globaGridMode.switchProviderSignal.next(true);
                                    // window.location.href = "/";
                                    // this.cookieService.deleteCookie("_zp");
                                    //   this.wo
                                } else {
                                    this.currentProvider;
                                    this.hideApp = false;
                                    this.setBlurFX = false;
                                    console.log("UNBLURACTION");
                                    rs();
                                }
                            });
                        } catch (e) {
                            console.log(e);
                            rj();
                        }
                        // }
                    }
                    //}
                } else {
                    if (provider != Providers.GAIN) {
                        rs();
                    } else {
                        try {
                            console.log("BLURACTION");
                            this.hideApp = false;
                            this.setBlurFX = true;
                            ShowLoginProviderModal(
                                this.modalService,
                                false,
                                "",
                                this.workspace.mobileMode,
                                "",
                                "",
                                true,
                                false
                            ).finally(() => {
                                if (this.workspace.gainLoginResponse == undefined) {
                                    this.setBlurFX = false;
                                    window.location.href = "/";
                                    this.cookieService.deleteCookie("_zp");
                                } else {
                                    this.hideApp = false;
                                    this.setBlurFX = false;
                                    console.log("UNBLURACTION");
                                    rs();
                                }
                            });
                        } catch (e) {
                            console.log(e);
                            rj();
                        }
                    }
                }
            });
            //TODO seve and load gain user credentials;
        });
    }

    private _setBlurFX: boolean = false;
    public get setBlurFX(): boolean {
        return this._setBlurFX;
    }
    public set setBlurFX(value: boolean) {
        this._setBlurFX = value;
    }

    /*cannot use search in this function....why?*/
    objectString(obj: BoxQuotaData, term: string): string {
        var search: string = "";
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const element: any = (<any>obj)[key];
                if (element) {
                    search += element.toString();
                }
            }
        }
        return search;
    }

    resizing(event: ResizeEvent) {
        if (event.rectangle.width) {
            this.menuWidth = Math.min(Math.max(event.rectangle.width, 300), 570);
        }
    }

    @HostListener("window:resize", ["$event"])
    onResize(event: any) {
        //  event.target.innerWidth;

        this.menuWidth = this.menuPan.nativeElement.offsetWidth; //Math.min(Math.max(event.rectangle.width, 300), 570);
    }

    public get menuWidth(): number {
        if (this._menuWidth == -1) {
            return this.menuPan.nativeElement.offsetWidth;
        } else {
            return this._menuWidth;
        }
    }

    private _menuWidth: number = -1;
    public set menuWidth(v: number) {
        this._menuWidth = v;
    }

    setDisplayMode(mode: number): void {
        this.quoteDisplayMode = mode;
    }

    public set showQuotePanel(v: boolean) {
        this.workspace.showQuotePanel = v;
    }

    public get showQuotePanel(): boolean {
        return this.workspace.showQuotePanel;
    }

    public set showTradeDesk(v: boolean) {
        // if (!v && this.selectedChart.onHideTradeDeskAction) {
        //     for (let l = 0; l < this.selectedChart.tradingLines.length; l++) {
        //         this.selectedChart.tradingLines[l].tempTradeData = null;
        //         this.selectedChart.tradingLines[l].removeTradeLines();
        //     }
        // }

        this.workspace.showTradeDesk = v;
    }

    public get showTradeDesk(): boolean {
        return this.workspace.showTradeDesk;
    }

    public get layoutMode(): string {
        return this.workspace.layoutMode;
    }

    private reInitChart(achrt: AChartComponent) {
        // if (achrt && (!achrt.refreshPeriosCalled || this.workspace.chartDisplayMode == ChartDisplayMode.ENTSIGNALS)) {
        //     setTimeout(() => {
        //         achrt.updateChartDisplay(this.workspace.chartDisplayMode).then(() => {
        //             achrt.refreshPeriod();
        //         });
        //     }, 50);
        // }
    }

    /*based on 4 charts*/
    setChartDisplaySet(state: string): void {
        switch (state[0]) {
            case "4":
                this.chartsRowState = [
                    ["col-6", "h-50"],
                    ["col-6", "h-50"],
                    ["col-6", "h-50"],
                    ["col-6", "h-50"]
                ];
                break;
            case "3":
                this.chartsRowState = [
                    ["col-12", "h-50"],
                    ["col-6", "h-50"],
                    ["col-6", "h-50"],
                    ["d-none", "h-50"]
                ];
                break;
            case "1":
                //
                if (state.length >= 2) {
                    switch (state[1]) {
                        case "1":
                            this.chartsRowState = [
                                ["col-12", "h-100"],
                                ["d-none", "h-50"],
                                ["d-none", "h-50"],
                                ["d-none", "h-50"]
                            ];
                            break;
                        case "2":
                            this.chartsRowState = [
                                ["d-none", "h-50"],
                                ["col-12", "h-100"],
                                ["d-none", "h-50"],
                                ["d-none", "h-50"]
                            ];
                            break;
                        case "3":
                            this.chartsRowState = [
                                ["d-none", "h-50"],
                                ["d-none", "h-50"],
                                ["col-12", "h-100"],
                                ["d-none", "h-50"]
                            ];
                            break;
                        case "4":
                            this.chartsRowState = [
                                ["d-none", "h-50"],
                                ["d-none", "h-50"],
                                ["d-none", "h-50"],
                                ["col-12", "h-100"]
                            ];
                            break;
                    }
                } else {
                    this.chartsRowState = [
                        ["col-12", "h-100"],
                        ["d-none", "h-50"],
                        ["d-none", "h-50"],
                        ["d-none", "h-50"]
                    ];
                }
                break;
            case "2":
                this.chartsRowState = [
                    ["col-12", "h-50"],
                    ["col-4", "h-50"],
                    ["col-4", "h-50"],
                    ["col-4", "h-50"]
                ];
                break;
        }
        this.workspace.layoutMode = state;
        this.reInitChart(this.workspace.charts["ach2"].instance!);
        this.reInitChart(this.workspace.charts["ach3"].instance!);
        this.reInitChart(this.workspace.charts["ach4"].instance!);

     
    }

    



    @ViewChild("carousel") carousel!: NgbCarousel;
    public initScroll() {
        $(".boxes").mCustomScrollbar({
            axis: "y",
            theme: "inset-3", // "minimal-dark",
            scrollbarPosition: "outside",
            alwaysShowScrollbar: 1, // 0,1,2
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                enable: true
            }
        });

        //  this.carousel.cycle();
        this.recurrentInit();
    }

    public recurrentInit() {
        setTimeout(() => {
            this.sliderAction();
        }, 5000);
    }

    private _slideId: string = "";
    public get slideId(): string {
        return this._slideId;
    }
    public set slideId(value: string) {
        this._slideId = value;
    }

    public sliderAction() {
        if (this.carousel != undefined) {
            this.carousel.cycle();

            if (this.slideId == this.carousel.activeId || this.slideId == "") {
                this.recurrentInit();
                //  console.log("SLIDE");
            }

            if (this.carousel != undefined) {
                this.slideId = this.carousel.activeId;
            }
        }
    }

    public activeSlide(e: any) {
        //    console.log("SLIDE");
        console.log(e);
    }

    ngAfterViewInit(): void {
        this.initScroll();
    }

    ngOnInit(): void {}
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    set activeTab(tabId: QuotePanelsTabsList) {
        this.workspace.activeTab = tabId;

        //  if()
    }

    get activeTab(): QuotePanelsTabsList {
        return this.workspace.activeTab;
    }

    public showModalOrderEntry(): void {
        ShowModalOrderEntry(
            "",
            0,
            this.modalService,
            OrderOperationType.Buy,
            "",
            this.workspace.mobileMode,
            undefined,
            this.workspace.newOrderLayout
        );
    }

    private _focusedSeach: boolean = false;

    public set focusedSearch(v: boolean) {
        this._focusedSeach = v;
    }

    public get focusedSearch() {
        return this._focusedSeach;
    }

    public focusSearch() {
        this.focusedSearch = true;
        console.log("FOC");
    }

    public focusoutSearch() {
        this.focusedSearch = false;
        console.log("UNFOC");
    }

    public calculateFlexBasis(type: string) {
        return 25 + "%";
    }

    public showSelectSetModal() {
        this.workspace
            .loadUserSets()
            .then(s => {
                SelectedParametersSetModal(this.modalService);
            })
            .catch(error => {
                console.error(error);
            });

        //   let items = Object.keys(this.workspace.parametersSet)|| [];;
        // this.workspace.selectedSet = items[0];
    }

    public get userSelectHeight() {
        return this.userSelectMainCol.nativeElement.offsetHeight;
    }

    calculateMenuWidth() {
        let hF = 0;
        if (this.competitionInformationContainerHeight != 0) {
            hF = 5;
        }

        if (this.menuWidth && this.menuWidth < 0) {
            return {
                width: "25%",
                height: "calc( 100% - " + (this.competitionInformationContainerHeight + hF) + "px )"
            };
        }
        return {
            flex: "0 0 " + this.menuWidth + "px",
            width: this.menuWidth + "px",
            height:
                "calc( 100% - " +
                (this.competitionInformationContainerHeight + hF + this.userSelectHeight - 30) +
                "px )"
        };
    }

    public get calculateHeightPanel() {
        let h = 40;

        if (this.userSelectHeight < 40) {
            h = this.userSelectHeight + 14;
        } else {
            h = 55;
        }

        if (this.currentProvider != "DEMO") {
            h = 40;
        }

        return {
            "padding-top": "8px !important",
            height: "calc( 100% - " + h + "px )"
        };
    }

    public get currentProvider() {
        return this.workspaceService.data.currentProvider;
    }

    calculateOverlayHeight() {
        return {
            height: "calc( 100% - " + this.userSelectHeight + "px )"
        };
    }

    calculateChartsWidth() {
        if (!this.showQuotePanel) {
            return {};
        }

        if (this.menuWidth && this.menuWidth < 0) {
            return {
                flex: "0 0 calc(75% - 34px)",
                "max-width": "calc(75% - 34px)"
            };
        }
        return {
            flex: `0 0 calc(100% - ${this.menuWidth + 34}px)`,
            "max-width": `calc(100% - ${this.menuWidth + 34}px)`
        };
    }

    calculateHomeWidth() {
        if (!this.showQuotePanel) {
            return {
                height: "calc(100% + 50px)"
            };
        }

        if (this.menuWidth && this.menuWidth < 0) {
            return {
                flex: "0 0 calc(75%)",
                "max-width": "calc(75%)",
                height: "calc(100% + 60px)"
            };
        }
        return {
            flex: `0 0 calc(100% - ${this.menuWidth}px)`,
            "max-width": `calc(100% - ${this.menuWidth}px)`,
            height: "calc(100% + 60px)"
        };
    }

    /*validateResize(event: ResizeEvent) doesnt work*/
    tradeDeskResizeEnd(event: ResizeEvent): void {
        let tempHeightCalculate = Math.max(
            event.rectangle.height || this._defaultTradeDeskHeight,
            this._minTradeDeskHeight
        );
        //let maxHeight = 0.5 * this.mainColumn.nativeElement.offsetHeight;
        let maxHeight = this.mainColumn.nativeElement.offsetHeight;
        let minHeight = 0; //0.05 * this.mainColumn.nativeElement.offsetHeight;

        if (tempHeightCalculate > maxHeight) {
            this.tradeDeskHeight = maxHeight;
        } else if (tempHeightCalculate < minHeight) {
            this.tradeDeskHeight = minHeight;
        } else {
            this.tradeDeskHeight = tempHeightCalculate;
        }
    }

    @HostListener("document:click", ["$event"])
    documentClick(event: MouseEvent) {
        //  if(this.showTradeVolumeSubmenu==true)
        //     {
        if ((<Element>event.target).className != "tradeVolumeOpener") {
            //  this.showTradeVolumeSubmenu=false;
            this.globaGridMode.volumeOpened.next("@_HIDE_@");
        }
        //  this.showTradeVolumeSubmenu=false;
        //    }
        // console.log("CLICKANYWHERE");basketMenuOpener
        if ((<Element>event.target).className != "basketMenuOpener") {
            //   this.showRemoveBasketMenu = false;
            //   this.showAddToBasketMenu = false;
        }
    }

    get basketItems() {
        return this.workspace.Baskets;
    }

    public get activeBasket() {
        return this.workspace.activeBasket;
    }

    public set activeBasket(id: number) {
        if (this.workspace.activeBasket != id) this.workspace.activeBasket = id;
    }

    public updateSortOrder(id: number) {
        if (id > -1) {
            console.log("id");
            console.log(id);
            let BasketOrder = this.workspace.getItemsFromBasket(id).items;

            BasketOrder.forEach(element => {
                let index = BasketOrder.indexOf(element);
                this.setOrderForSymbol(element, index);
            });
        }
    }

    setOrderForSymbol(symbol: string, sortOrder: number) {
        this.boxes.filter(x => x.Symbol == symbol).forEach(x => (x.sortOrder = sortOrder));
    }

    public get activeBasketItems() {
        return this.workspace.getActiveBasketItems();
    }

    public trackItem(index: number, item: any) {
        return item.trackId;
    }

    private _showRemoveBasketMenu: boolean = false;

    public showAddSymbolsToBasketModal() {
        let list = Object.assign([], this.workspace.Baskets[this.activeBasket].items);
        ShowAddToBasketModal(
            this.modalService,
            this.workspace.loadedSymbolsTypeSplit,
            list,
            this.activeBasket,
            this.workspace.mobileMode
        );
    }

    filterLefttabs: object = quoteFilterTabsParams();

    public set activeQuoteFilter(tabId: SymbolTypeEnum) {
        this.workspace.activeSymbolType = tabId;
        this.searchQuoteFullText(this._currentSearchString);
    }

    public get activeQuoteFilter(): SymbolTypeEnum {
        return this.workspace.activeSymbolType;
    }

    public toggleActiveBasket(v: number) {
        this.activeBasket = this.activeBasket == v ? -1 : v;
    }
    public leftTabPaddings: number[] = [32, 18, 49, 22, 24, 18];
    public leftBasketPaddings: number[] = [55, 32, 32, 32, 32, 32];

    get userParameterSets() {
        if (this.workspace.mobileMode == "desktop" && this.workspace.usersetList != undefined) {
            return this.workspace.usersetList.filter((v: any) => {
                return v.id.substr(0, 1) != "m";
            });
        }

        //   console.log(this.workspace.usersetList);

        return this.workspace.usersetList;
    }

    public get homeSetSelect() {
        return this.workspace.selectedSet;
    }
    public set homeSetSelect(value: string | null) {
        //   debugger;
        this.workspace.selectedSet = value;
    }

    onChangehomeSetSelect(e: any) {
        //    debugger;
        this.workspace.changeSelectedSet(e);
    }

    public get tournamentsWithoutUser(): TournamentWithAccountId[] | null | undefined {
        return this.workspace.tournamentsWithoutUser;
    }

    public get tournamentsWithUser(): TournamentWithAccountId[] | null | undefined {
        return this.workspace.tournamentsWithUser;
    }

    private _isActiveCompetition: boolean = false;
    public get isActiveCompetition(): boolean {
        if (this.workspace.isActiveCompetition) {
            //  console.log(this.competitionInformationContainerHeight);
        }

        return this.workspace.isActiveCompetition;
        //this._isActiveCompetition;
    }
    public set isActiveCompetition(value: boolean) {
        this._isActiveCompetition = value;
    }

    public get competitionInformationContainerHeight() {
        if (this.competitionInformationContainer === undefined) {
            return 0;
        }

        return this.competitionInformationContainer.nativeElement.offsetHeight || 0;
    }

    public get isActiveAdvertisement(): boolean {
        return this.workspace.isActiveAdvertisement;
    }

    public get advertismentsList(): Adveristment[] {
        return this.workspace.activeAdvertisements;
    }

    public advertisementAction(link: string) {
        switch (link) {
            case "action:openliveaccount":
                if (this.workspace.mobileMode == "desktop") {
                    ShowOpenLiveAccountModal(this.modalService);
                } else {
                    ShowOpenLiveAccountMobileModal(this.modalService);
                }
                return;
        }

        return;
    }

    public checkUrlIsAction(link: string) {
        if (!link) {
            return false;
        }
        return link.startsWith("action:");
    }

    public get urlPref() {
        if (this.workspace.debugVisibility) {
            return "http://dix.infosystrade.com";
        } else {
            return "";
        }
    }

    public get showLandingPage(): boolean {
        return this.workspace.showLandingPage;
    }

    public showLandingPageAction() {
        this.workspace.showLandingPage = true;
        this.workspace.showAppStore = false;
        this.workspace.showScannerPage = false;
        this.workspace.showBackToResults = false;
    }

    public get showScannerPage(): boolean {
        return this.workspace.showScannerPage;
    }

    public get showAppStore(): boolean {
        return this.workspace.showAppStore;
    }

    public set showAppStore(val: boolean) {
        // this.workspace.showScannerPage = false;
        // this.workspace.showLandingPage = false;
        // this.workspace.showAppStore = true;

        // this.workspace.appStoreData();
        this.workspace.showAppStoreAction();
    }

    @HostListener("document:keyup", ["$event"])
    handleDeleteKeyboardEvent(event: KeyboardEvent) {
        //console.log(event.key);
        //  if(event.key === 'Escape')
        //   {
        // remove something...
        if (this.workspace.forceDisconnection) {
            this.forceLogout();
            // this.modalService.dismissAll();
        }

        //     }
    }

    @HostListener("document:click", ["$event"])
    clickout(even: any) {
        if (this.workspace.forceDisconnection) {
            //    this.forceLogout();
            // this.modalService.dismissAll();
        }

     //   console.log(even);

        if (this.workspace.allowFunnelAction) {
            let allowFunnelFinish = true;
            // var BreakException = {};
            var path = even.path || (even.composedPath && even.composedPath());

            if (path != undefined) {
                path.forEach((t: any) => {
                    console.log(t.className);
                    let str: string = t.className;

                    if (str !== undefined) {
                        if (str.includes("leaderboard") || str.includes("fade")) {
                            //   console.log("NOT ALLOWED ACTION");
                            allowFunnelFinish = false;
                            //     throw BreakException;
                        }
                    }
                });
            }

            console.log("allowFunnelFinish");
            console.log(allowFunnelFinish);
            if (allowFunnelFinish) {
                this.workspace.tutorialPanelShown = true;
                this.workspace.activeTutorialVideo = "wa3aqbaede";
                if (this.workspace.tutorialVideoWindow) this.workspace.tutorialVideoWindow.bigWindow = true;
                this.workspace.allowFunnelAction = false;
            }
        }
    }

    @HostListener("document::contextmenu", ["$event"])
    clickright(even: any) {
        if (this.workspace.forceDisconnection) {
            //    this.forceLogout();
            // this.modalService.dismissAll();
        }
    }

    private _showLoaderComponent: boolean = false;
    public get showLoaderComponent(): boolean {
        return this._showLoaderComponent;
    }
    public set showLoaderComponent(value: boolean) {
        this._showLoaderComponent = value;
    }

    public ctabs: object = challengeTabsParams();

    public get challengeActiveTab(): challengeTabsList {
        return this.workspace.challengeActiveTab;
    }
    public set challengeActiveTab(value: challengeTabsList) {
        this.workspace.challengeActiveTab = value;
    }

    public get tournamentOverlay() {
        //if(this.activeSymbolType!=this.allowedAssetTypes)

        if (
            this.activeTab != QuotePanelsTabsList.SYMBOL &&
            this.activeTab != QuotePanelsTabsList.MONITOR &&
            this.activeTab != QuotePanelsTabsList.WIZARD
        ) {
            return false;
        }

        if (this.workspace.availableAssetsForUser != undefined) {
            if (
                this.workspace.tournamentUserSelected &&
                this.workspace.availableAssetsForUser!.indexOf(this.workspace.activeSymbolType) == -1
            ) {
                return true;
            }
        }
        return false;
    }

    public get tournamentHeaderImage(): string | null | undefined {
        return this.workspace.tournamentWithActiveAccountId[0].headerImage;
    }

    private _tournamentOverlayImage: string | null | undefined = "/images/challenges/overlay-tournament-may.png";
    public get tournamentOverlayImage(): string | null | undefined {
        return this.workspace.tournamentWithActiveAccountId[0].overlayHtml;
    }

    public showOtherChallenges() {
        this.workspace.activeTab = QuotePanelsTabsList.LEADERBOARD;
        this.workspace.challengeActiveTab = challengeTabsList.UPCOMING;
    }

    public checkCompetitionAdvertising(competition: TournamentWithAccountId) {
        let startAdvertisingShow = competition.startAdvertisingDateUtc.utc();
        let endAdvertisingShow = competition.endAdvertisingDateUtc.utc();
        let today = moment().utc();
        return today.isBetween(startAdvertisingShow, endAdvertisingShow);
    }

    // pageNumber: number = 0;
    // @ViewChild("Carousel") _carousel!: Carousel;

    // onPrev(): void {
    //     this._carousel.previous();
    // }

    // onNext(): void {
    //     this._carousel.next();
    // }
    public openScanResults() {
        this.workspace.showScannerPage = true;
        this.workspace.showAppStore = false;
        this.workspace.activeTab = QuotePanelsTabsList.SCANNER;
    }

    public get scannerAccess() {
        return this.dataService.AllowScannerAccess;
    }


    public getCookiesService()
    {
        return this.dataService.cookiesAccepted;
    }
    
    public get mobileScannerAccess() {
        return this.dataService.AllowScannerMobile;
    }
}
